import { ApiService } from '../../constants';
import { HttpService } from '../../utilities';

interface GetTransaksiRedeem {
  search?: string;
  userin?: string;
  scheduleid?: string;
  page?: number;
  size?: number;
  status?: string;
  dateIn?: string;
}

export const getTransaksiRedeem = ({
  search = '',
  page,
  size,
  scheduleid = '',
  userin = '',
  status = '',
  dateIn = ''
}: GetTransaksiRedeem) => {
  return HttpService.get(
    `${
      ApiService.icdc.module.inventoryReward.getTransaksiRedeem
    }?search=${search}&page=${page}&userin=${userin || ''}&status=${
      status || ''
    }&dateIn=${dateIn || ''}&take=100`
  );
};

export const pickVoucher = (data: any) => {
  return HttpService.post(ApiService.icdc.module.inventoryReward.pick, data);
};
